/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    "./node_modules/flowbite-react/**/*.js",
    "./pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./components/**/*.{js,ts,jsx,tsx,mdx}",
    "./node_modules/tw-elements-react/dist/js/**/*.js",

    "./app/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
    container: {
      center: true,

      padding: {
        DEFAULT: "1rem",
        sm: "3rem",
        lg: "12rem",
        xl: "131px",
        "2xl": "150px",
        "3xl": "192px",
      },
    },
    extend: {
      backgroundSize: {
        "144%": "144%",
      },
      backgroundImage: {
        "home-main": "url('/images/main.webp')",
        bg4: "url('/images/bg4.svg')",
        "circles-bg": "url('/images/circlesbg.svg')",
        "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
        "gradient-conic":
          "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
      },
      boxShadow: {
        button: "0 35px 60px -15px rgba(0, 0, 0, 0.3)",
        inset: "inset 0px 5px 6px #00000038",
        insetMd: "inset 0px 3px 6px #00000029",
        select: "inset 0px 3px 6px #00000017",

        card: "0px 3px 6px #00000029",
        project: "0px 5px 25px #00000029",
        graduste: "0px 5px 12px #00000029",
        cardLg: "0px 3px 6px #00000029;",
      },
      dropShadow: {
        "2xl": "0px 1px 4px rgba(0, 0, 0, 0.1)",

        "3xl": " 0px 5px 18px rgba(0, 0, 0,  0.1)",
        btn: "0px 5px 16px #00000042",
      },
      colors: {
        white: "#FFFFFF",
        fontLight: "#ECECF5",
        orange: "#ff7849",
        primary200: "#D8E1FF",
        primary100: "#F6F6FF",
        primaryLight: "#758BD8",
        primary: "#1A0645",
        primaryDark: "#1A0645",
        secondary: "#52A8F2",
        secondaryDark: "#469EF0",
        gray100: "#FAFAFA00",
        gray200: "#FAFAFA",
        gray300: "#222A48",
        gray400: "#000000",
        gray: "#000000",
        dark: "#121126",
        orangeLight: "#F2A20C",
        orangDark: "#F25B22",
        redDark: "#C51E0B",
        red: "#F22E2E",
        yellow: "#F2E30C",
        green: "#2BD988",
      },
      // typography: (theme) => ({
      //   mdx: {
      //     css: {
      //       fontSize: '18px',
      //       lineHeight: '1.75',
      //       p: {
      //         fontSize: '18px',
      //         lineHeight: '1.75',
      //       },
      //       li: {
      //         fontSize: '18px',
      //         lineHeight: '1.75',
      //       },
      //       h1: {
      //         fontSize: '1.875rem', // 30px
      //         lineHeight: '2.25rem', // 36px
      //       },
      //       h2: {
      //         fontSize: '1.5rem', // 24px
      //         lineHeight: '2rem', // 32px
      //       },
      //       h3: {
      //         fontSize: '1.25rem', // 20px
      //         lineHeight: '1.75rem',
      //       },
      //     },
      //   },
      // }),
    },
    screens: {
      "3xsm": "279px",
      "2xsm": "346px",
      xsm: "355px",
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1596px",
      "3xl": "1763px",
    },
  },
  plugins: [
    require('@tailwindcss/typography'),
    require("flowbite/plugin"),
    require("tw-elements-react/dist/plugin.cjs"),
  ],
};
